import { motion } from "framer-motion";
import { Check, Star } from "lucide-react";
import { GradientButton, GhostButton } from "./primitives";

// Reusable pricing card. `onView` optional (scroll to details); otherwise routes.
export default function PackageCard({ pkg, index = 0, onCta, ctaLabel }) {
  const isPopular = pkg.popular;
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ y: -8 }}
      data-testid={`package-card-${pkg.id}`}
      className={[
        "group relative flex h-full flex-col overflow-hidden rounded-3xl border p-8",
        isPopular
          ? "border-brand/40 bg-white/[0.05] shadow-[0_20px_60px_-20px_rgba(255,90,54,0.45)]"
          : "border-white/10 bg-white/[0.03]",
      ].join(" ")}
    >
      {isPopular && (
        <>
          <div className="absolute -right-16 -top-16 h-40 w-40 rounded-full bg-brand/20 blur-3xl" />
          <span className="absolute right-6 top-6 inline-flex items-center gap-1.5 rounded-full bg-brand-gradient px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-white">
            <Star className="h-3 w-3 fill-white" /> Most Popular
          </span>
        </>
      )}

      <h3 className="font-heading text-lg font-semibold text-white">{pkg.name}</h3>
      <p className="mt-1.5 text-sm text-muted-foreground">{pkg.tagline}</p>

      <div className="mt-6 flex items-end gap-1.5">
        <span className={isPopular ? "font-heading text-4xl font-bold text-gradient" : "font-heading text-4xl font-bold text-white"}>
          {pkg.price}
        </span>
        <span className="mb-1 text-sm text-muted-foreground">{pkg.per || pkg.currency}</span>
      </div>

      <ul className="mt-7 flex-1 space-y-3">
        {pkg.features.map((f) => (
          <li key={f} className="flex items-start gap-2.5 text-sm text-muted-foreground">
            <Check className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
            <span>{f}</span>
          </li>
        ))}
      </ul>

      <div className="mt-8">
        {isPopular ? (
          <GradientButton
            className="w-full"
            to={onCta ? undefined : "/contact"}
            onClick={onCta}
            data-testid={`package-cta-${pkg.id}`}
          >
            {ctaLabel || (pkg.custom ? "Get a Custom Quote" : "Get Started")}
          </GradientButton>
        ) : (
          <GhostButton
            className="w-full"
            to={onCta ? undefined : "/contact"}
            onClick={onCta}
            data-testid={`package-cta-${pkg.id}`}
          >
            {ctaLabel || (pkg.custom ? "Contact Us for a Custom Quote" : "View Details")}
          </GhostButton>
        )}
      </div>
    </motion.div>
  );
}
